import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";
import { toast } from "react-hot-toast";

export const useGetStatusWizardGroupPay = () => {
  const onError = () => {
    toast.error("Erro ao buscar o status do wizard");
  };

  return useFetch({
    key: ["status-wizard", "CONFIGURACAO_GROUP_PAY"],
    url: api.wizard.buscarStatusWizard,
    onError,
    pathVariables: "CONFIGURACAO_GROUP_PAY",
    config: {
      staleTime: Infinity,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      refetchOnMount: false,
    },
  });
};
